import { render, staticRenderFns } from "./CompanyUpload.vue?vue&type=template&id=d256f362&scoped=true&"
import script from "./CompanyUpload.vue?vue&type=script&lang=js&"
export * from "./CompanyUpload.vue?vue&type=script&lang=js&"
import style0 from "./CompanyUpload.vue?vue&type=style&index=0&id=d256f362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d256f362",
  null
  
)

export default component.exports